import locationCreateComponent from './location.create.component';

let locationCreateModule = angular.module('locationcreate', [
    'ngMap'
  ])

  .component('locationcreate', locationCreateComponent)

  .name;

export default locationCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/location/create/index.js